import React, { Fragment, useState } from 'react';
import Navbar from '../../components/Navbar/Navbar';
import { Link } from 'react-router-dom'
import PageTitle from '../../components/pagetitle/PageTitle'
import Scrollbar from '../../components/scrollbar/scrollbar'
import { useParams } from 'react-router-dom'
import Footer from '../../components/footer/Footer';
import Causes from '../../api/cause'
import Logo from '../../images/logo.png'


const CauseSinglePage = (props) => {
    const { slug } = useParams()

    const caseDetails = Causes.find(item => item.slug === slug)

    const [formData, setFormData] = useState({
        firstName: '',
        lastName: '',
        email: '',
        anonymous: false,
        comment: '',
        donationType: '',
        website: '', // honeypot
    });


    const ClickHandler = () => {
        window.scrollTo(10, 0);
    }

    const handleChange = e => {
        const { name, value, type, checked } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: type === 'checkbox' ? checked : value,
        }));
    };

    const handleDonationType = (value) => {
        setFormData(prev => ({
            ...prev,
            donationType: value,
        }));
    };

    const [submitting, setSubmitting] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();

        // Honeypot check — if filled, it's a bot
        if (formData.website) {
            console.warn("Bot submission detected");
            return;
        }

        // Basic validation (redundant, but helpful as a safety net)
        if (!formData.firstName || !formData.email || !formData.donationType) {
            alert("Please complete all required fields.");
            return;
        }

        try {
            setSubmitting(true);
            const response = await fetch("https://formsubmit.co/ajax/001990bd29b268f3192e58ea1a208d3c", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    Accept: "application/json",
                },
                body: JSON.stringify({
                    FirstName: formData.firstName,
                    LastName: formData.lastName,
                    Email: formData.email,
                    DonationType: formData.donationType,
                    Anonymous: formData.anonymous ? 'Yes' : 'No',
                    Comment: formData.comment
                }),
            });

            if (!response.ok) {
                throw new Error("Submission failed");
            }

            // Only redirect on valid submit
            window.location.href = "https://www.paypal.com/donate/?hosted_button_id=84NNZS7M275RJ";
        } catch (error) {
            alert("Failed to send. Please try again.");
        } finally {
            setSubmitting(false);
        }
    };


        return (
        <Fragment>
            <Navbar hclass={'header-style-1'} Logo={Logo} btnClass={'theme-btn-s1'} />
            <PageTitle pageTitle={caseDetails.cTitle} pagesub={'Project'} />
            <section className="case-single-section section-padding">
                <div className="container">
                    <div className="row">
                        <div className="col col-xl-8 col-lg-7 col-12">
                            <div className="img-holder details-img">
                                <img src={caseDetails.cImg} alt="" />
                            </div>
                        </div>
                        <div className="col col-xl-4 col-lg-5 col-12">
                            <div className="case-info-area">
                                <h3>During these uncertain times, it’s important to reach out to help </h3>
                                <div className="goal-raised">
                                    <div><span>Goal:</span> $500</div>
                                    <div><span>Raised:</span> $300</div>
                                </div>
                                {/*<div className="progress">*/}
                                {/*    <div className="progress-bar" style={{ width: `${caseDetails.process}%` }}>*/}
                                {/*        <span className="progress-value">{caseDetails.process}%</span>*/}
                                {/*    </div>*/}
                                {/*</div>*/}
                                <p>Housed in a nice, gilded frame. It showed a lady fitted out with a fur hat and fur boa who sat upright, raising a heavy fur muff that covered the whole of her lower arm towards the viewer gregor then turned</p>
                                <div className="social-area">
                                    <ul>
                                        <li><Link onClick={ClickHandler} to="/"><i className="ti-facebook"></i></Link></li>
                                        <li><Link onClick={ClickHandler} to="/"><i className="ti-instagram"></i></Link></li>
                                    </ul>

                                    <span>Follow us</span>
                                </div>
                                <p>NB: Please give the donation using bang bang</p>
                            </div>
                        </div>
                    </div>
                    <div className="row donate-area-bottom">
                        <div className="col col-lg-8 col-12">
                            <div className="donate-area-wrapper">
                                <h3>What should we put your donation toward?</h3>
                                <form onSubmit={handleSubmit} id="give-form-232-1" className="give-form give-form-232 give-form-type-multi" data-id="232-1" data-currency_symbol="&#36;" data-currency_code="USD" data-currency_position="before" data-thousands_separator="," data-decimal_separator="." data-number_decimals="2" method="post">

                                    <ul id="give-donation-level-button-wrap" className="give-donation-levels-wrap give-list-inline">
                                        <li>
                                            <button type="button" onClick={() => handleDonationType("Medical")} data-price-id="0" className="give-donation-level-btn give-btn give-btn-level-0 give-default-level" value="1.00" data-default="1">Medical</button>
                                        </li>
                                        <li>
                                            <button type="button" onClick={() => handleDonationType("Education")} data-price-id="1" className="give-donation-level-btn give-btn give-btn-level-1 " value="50.00" data-default="0">Education</button>
                                        </li>
                                        <li>
                                            <button type="button" onClick={() => handleDonationType("Sports")} data-price-id="2" className="give-donation-level-btn give-btn give-btn-level-2 " value="100.00" data-default="0">Sports</button>
                                        </li>
                                        <li>
                                            <button type="button" onClick={() => handleDonationType("Creative")} data-price-id="3" className="give-donation-level-btn give-btn give-btn-level-3 " value="150.00" data-default="0">Creative</button>
                                        </li>
                                        <li>
                                            <button type="button" onClick={() => handleDonationType("Custom Amount")} data-price-id="custom" className="give-donation-level-btn give-btn give-btn-level-custom" value="custom">Custom Amount</button>
                                        </li>
                                    </ul>

                                    <div id="give_purchase_form_wrap">
                                        {/* Honeypot field to trap bots */}
                                        <input type="text" name="website" style={{ display: 'none' }} onChange={handleChange} value={formData.website || ''} autoComplete="off" tabIndex="-1" />

                                        <fieldset id="give_checkout_user_info" className="">
                                            <legend> Please Let Us Know who You Are!</legend>
                                            <p id="give-first-name-wrap" className="form-row form-row-first form-row-responsive">
                                                <label className="give-label" htmlFor="give-first"> First Name
                                                    <span className="give-required-indicator">*</span>
                                                    <span className="give-tooltip hint--top hint--medium hint--bounce" aria-label="First Name is used to personalize your donation record." rel="tooltip">
                                                        <i className="give-icon give-icon-question"></i>
                                                    </span>
                                                </label>
                                                <input className="give-input required" type="text" name="firstName" autoComplete="given-name" placeholder="First Name" id="give-first"
                                                    value={formData.firstName} onChange={handleChange} required aria-required="true" />
                                            </p>

                                            <p id="give-last-name-wrap" className="form-row form-row-last form-row-responsive">
                                                <label className="give-label" htmlFor="give-last">
                                                    Last Name
                                                    <span className="give-tooltip hint--top hint--medium hint--bounce" aria-label="First Name is used to personalize your donation record." rel="tooltip">
                                                        <i className="give-icon give-icon-question"></i>
                                                    </span>
                                                </label>

                                                <input className="give-input" type="text" name="lastName" autoComplete="family-name" id="give-last" placeholder="Last Name" value={formData.lastName} onChange={handleChange} />
                                            </p>


                                            <p id="give-email-wrap" className="form-row form-row-wide">
                                                <label className="give-label" htmlFor="give-email">
                                                    Email Address
                                                    <span className="give-required-indicator">*</span>
                                                    <span className="give-tooltip hint--top hint--medium hint--bounce" aria-label="First Name is used to personalize your donation record." rel="tooltip">
                                                        <i className="give-icon give-icon-question"></i>
                                                    </span>
                                                </label>
                                                <input className="give-input required" type="email" name="email" autoComplete="email" placeholder="Email Address" id="give-email"
                                                    value={formData.email} onChange={handleChange} required aria-required="true" />
                                            </p>

                                            <p id="give-anonymous-donation-wrap" className="form-row form-row-wide">
                                                <label className="give-label" htmlFor="give-anonymous-donation">
                                                    <input type="checkbox" className="give-input" name="anonymous" id="give-anonymous-donation" checked={formData.anonymous} onChange={handleChange}
                                                    /> Make this an anonymous donation.
                                                    <span className="give-tooltip hint--top hint--medium hint--bounce" aria-label="First Name is used to personalize your donation record." rel="tooltip">
                                                        <i className="give-icon give-icon-question"></i>
                                                    </span>
                                                </label>
                                            </p>

                                            <p id="give-comment-wrap" className="form-row form-row-wide">
                                                <label className="give-label" htmlFor="give-comment">
                                                    Instructions
                                                    <span className="give-tooltip hint--top hint--medium hint--bounce" aria-label="First Name is used to personalize your donation record." rel="tooltip">
                                                        <i className="give-icon give-icon-question"></i>
                                                    </span>
                                                </label>

                                                <textarea className="give-input" name="comment" placeholder="Leave special instructions" id="give-comment" value={formData.comment} onChange={handleChange}></textarea>
                                            </p>
                                        </fieldset>

                                        <fieldset id="give_purchase_submit" className="give-donation-submit">
                                            <input type="hidden" name="give_action" value="purchase" />
                                            <input type="hidden" name="give-gateway" value="manual" />

                                            <div className="give-submit-button-wrap give-clearfix">
                                                {/*<input type="submit" className="give-submit give-btn"*/}
                                                {/*       id="give-purchase-button" name="give-purchase" value="Donate Now"*/}
                                                {/*       data-before-validation-label="Donate Now"/>*/}

                                                <button type="submit" className="give-submit give-btn"
                                                        disabled={submitting}>
                                                    {submitting ? "Processing..." : "Donate Now"}
                                                </button>

                                                <script
                                                    src="https://www.paypal.com/sdk/js?client-id=5K79VN33EUUSL&currency=USD"></script>

                                                <span className="give-loading-animation"></span>
                                            </div>
                                        </fieldset>
                                    </div>
                                </form>
                            </div>
                        </div>
                        <div className="col col-lg-4 col-12">
                            <div className="case-single-sidebar">
                                <div className="widget contact-widget">
                                    <div>
                                        <p>Our email address:</p>
                                        <h5>info@loveofheartsfoundation.org</h5>
                                    </div>
                                </div>

                                <div className="widget urgent-case-widget">
                                    <div className="cases">
                                        {Causes.slice(0, 3).map((Cause, citem) => (
                                            <div className="case" key={citem}>
                                                <div className="img-holder">
                                                    <img src={Cause.cImg} alt="" />
                                                </div>
                                                {/*<div className="details">*/}
                                                {/*    <h4><Link onClick={ClickHandler} to={`/cause-single/${Cause.slug}`}>{Cause.cTitle}</Link></h4>*/}
                                                {/*    <span className="g-r">${Cause.Goal} raised of ${Cause.Raised}</span>*/}
                                                {/*</div>*/}
                                            </div>
                                        ))}

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <Footer />
            <Scrollbar />
        </Fragment>
    )
};
export default CauseSinglePage;
